import React from "react"

import Tooltip from "#React/ui/Tooltip"
import cn from "#Utils/cn"

interface TruncatedTextProps {
  text: React.ReactNode
  textClassName?: string
  tooltip?: React.ReactNode
  forceTooltip?: boolean
}

const TruncatedText = ({
  text,
  textClassName = "",
  tooltip = null,
  forceTooltip = false,
}: TruncatedTextProps) => {
  const [isTruncated, setIsTruncated] = React.useState(false)
  const textRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (!textRef.current) {
      setIsTruncated(false)
      return
    }

    setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth)
  }, [text])

  if (isTruncated || forceTooltip) {
    return (
      <Tooltip>
        <Tooltip.Trigger>
          <div ref={textRef} className={cn("truncate", textClassName)}>
            {text}
          </div>
        </Tooltip.Trigger>
        <Tooltip.Content side="bottom">
          <div className="py-2">{tooltip == null ? text : tooltip}</div>
        </Tooltip.Content>
      </Tooltip>
    )
  }

  return (
    <div ref={textRef} className={cn("truncate", textClassName)}>
      {text}
    </div>
  )
}

export default TruncatedText
